module.exports = __webpack_public_path__ + "static/media/Year-1977-background.f560695d.jpg";